import { apiBaseUrl } from '../core/globalVariables.js';

import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import harrierPolygonLayer from '../core/harrierPolygonLayer';
import { center } from '@turf/turf';
import { bbox } from '@turf/turf';
import booleanContains from '@turf/boolean-contains';
import CommsToAPI from '../ui/modals/commsToAPI.js'

import { ClockLoader } from "react-spinners";

import { getAvailableYears } from './getAvailableYears';

import {
  fmesh,
  fullmesh,
} from '../core/globalVariables.js';

const DataLoad = ({
  isMenuLoadClick,
  closeLoadMenu,
  globalRefs,
  globalState,
  mapLoaded,
  setLoggedInToAPI,
  setLoadedPercentage,
  resetLeftSubMenu,
}) => {

  const [mapData, setMapData] = useState([]);
  const [initFetch, setInitFetch] = useState(0);
  let userID = globalState.userID;
  let setUserID = globalState.setUserID
  let initialDataLoadComplete = globalState.initialDataLoadComplete;
  let setInitialDataLoadComplete = globalState.setInitialDataLoadComplete;

  const message = 'Loading new Data'

  let debugMode = globalState.debugMode;
  let setDebugMode = globalState.setDebugMode;

  const mapRef = globalRefs.mapRef;
  const polygonCustomLayerRef = globalRefs.polygonCustomLayerRef;
  const longstandingGeoJSONRef = globalRefs.longstandingGeoJSONRef;
  const originalGeoJSONforComparingRef = globalRefs.originalGeoJSONforComparingRef;
  let centroidRef = globalRefs.centroidRef;
  let APIReportMessage = globalState.APIReportMessage;
  let setAPIReportMessage = globalState.setAPIReportMessage;
  let currentMapIdRef = globalRefs.currentMapIdRef;
  let setRecentChangeList = globalState.setRecentChangeList;
  const setIsLoading = globalState.setIsLoading;
  const setisMenuLoadClick = globalState.setisMenuLoadClick;
  const currentMapId = globalState.currentMapId;
  const setCurrentMapId = globalState.setCurrentMapId;
  const selectedYearEditing = globalState.selectedYearEditing;
  let workingLocally = globalState.workingLocally;
  let setUserEmail = globalState.setUserEmail;
  let universalParcelDifferentiator = globalState.universalParcelDifferentiator;
  let universalColorPaletteName = globalState.universalColorPaletteName;
  let setAdminUser = globalState.setAdminUser;
  let globalPublicSelectedDataset = globalState.globalPublicSelectedDataset;
  let clickedMapIDtoLoad = globalState.clickedMapIDtoLoad;
  let isThisFirstLoadOfNewData = 0;
  let isDrawing = globalState.isDrawing;
  let setAvailableKeys = globalState.setAvailableKeys;
  let setAvailableValues = globalState.setAvailableValues;
  let yearsAvailable = globalState.yearsAvailable;
  let setYearsAvailable = globalState.setYearsAvailable;
  let setisComparing = globalState.setisComparing;
  const selectedKey = globalState.selectedKey;
  const selectedMetric = globalState.selectedMetric;
  const setisLeftSubDrawerOpen = globalState.setisLeftSubDrawerOpen;
  const setGlobalPublicSelectedDataset = globalState.setGlobalPublicSelectedDataset;
  const setClickedMapIDtoLoad = globalState.setClickedMapIDtoLoad;
  const isWorkingWithinRealm = globalState.isWorkingWithinRealm;
  const setIsWorkingWithinRealm = globalState.setIsWorkingWithinRealm;
  const setMapMetaData = globalState.setMapMetaData;
  const selectedFirstPrivateMapParentRef = globalRefs.selectedFirstPrivateMapParentRef;
  const devDeployment = globalState.devDeployment;
  const mapOverview = globalState.mapOverview;
  const setMapOverview = globalState.setMapOverview;
  const dataHasNoKeys = globalState.dataHasNoKeys;
  const setDataHasNoKeys = globalState.setDataHasNoKeys;
  const dataHasNoValues = globalState.dataHasNoValues;
  const setDataHasNoValue = globalState.setDataHasNoValues;
  const setMultuGroupSelectedArray = globalState.setMultuGroupSelectedArray;
  const baseMapIDRefForRefWhenUsingOriginalLayer = globalRefs.baseMapIDRefForRefWhenUsingOriginalLayer;

  let initiallyLoadedDataBoundingBox = useRef();
  let UpdatedMapLoadedPolygonCountAfterPanRef = useRef();
  let UpdatedMapLoadedPolygonCountAfterKeyValueChange = useRef();
  let simplificationLevelRef = useRef('0');
  const selectedKeyRef = useRef(selectedKey);
  const selectedMetricRef = useRef(selectedMetric);

  let clickedInfoTab = globalState.clickedInfoTab;
  let setClickedInfoTab = globalState.setClickedInfoTab;

  let userIsMapOwner = globalState.userIsMapOwner;
  let setUserIsMapOwner = globalState.setUserIsMapOwner;

  // 

  let LOADINGPARAM_startOfLoad = globalState.LOADINGPARAM_startOfLoad;
  let setLOADINGPARAM_startOfLoad = globalState.setLOADINGPARAM_startOfLoad;

  let LOADINGPARAM_makeScene = globalState.LOADINGPARAM_makeScene;
  let setLOADINGPARAM_makeScene = globalState.setLOADINGPARAM_makeScene;

  let LOADINGPARAM_initAnimation = globalState.LOADINGPARAM_initAnimation;
  let setLOADINGPARAM_initAnimation = globalState.setLOADINGPARAM_initAnimation;

  let LOADINGPARAM_onAdd = globalState.LOADINGPARAM_onAdd;
  let setLOADINGPARAM_onAdd = globalState.setLOADINGPARAM_onAdd;

  let LOADINGPARAM_createShapes = globalState.LOADINGPARAM_createShapes;
  let setLOADINGPARAM_createShapes = globalState.setLOADINGPARAM_createShapes;

  let LOADINGPARAM_applyDateRange = globalState.LOADINGPARAM_applyDateRange;
  let setLOADINGPARAM_applyDateRange = globalState.setLOADINGPARAM_applyDateRange;

  let LOADINGPARAM_resetMapAfterDatesReceived = globalState.LOADINGPARAM_resetMapAfterDatesReceived;
  let setLOADINGPARAM_resetMapAfterDatesReceived = globalState.setLOADINGPARAM_resetMapAfterDatesReceived;

  let LOADINGPARAM_fetchKeyData = globalState.LOADINGPARAM_fetchKeyData;
  let setLOADINGPARAM_fetchKeyData = globalState.setLOADINGPARAM_fetchKeyData;

  let LOADINGPARAM_fetchNumericData = globalState.LOADINGPARAM_fetchNumericData;
  let setLOADINGPARAM_fetchNumericData = globalState.setLOADINGPARAM_fetchNumericData;

  useEffect(() => {
    selectedKeyRef.current = selectedKey;
    selectedMetricRef.current = selectedMetric;
  }, [selectedKey, selectedMetric]);

  let setSelectedMetric = globalState.setSelectedMetric;
  let setSelectedKey = globalState.setSelectedKey;
  let setSelectedAggregate = globalState.setSelectedAggregate;
  let setNumericTimeAggregationMethod = globalState.setNumericTimeAggregationMethod;

  // START STAGE 5 - CREATE A NEW MAP LAYER WITH THE NEW GEOJSON - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
  // START STAGE 5 - CREATE A NEW MAP LAYER WITH THE NEW GEOJSON - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
  // START STAGE 5 - CREATE A NEW MAP LAYER WITH THE NEW GEOJSON - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

  const newMapFromGeojson = (geoJsonData, id) => {
    // 
    setLOADINGPARAM_startOfLoad(false)
    setLOADINGPARAM_makeScene(false)
    setLOADINGPARAM_initAnimation(false)
    setLOADINGPARAM_onAdd(false)
    setLOADINGPARAM_createShapes(false)
    setLOADINGPARAM_applyDateRange(false)
    setLOADINGPARAM_resetMapAfterDatesReceived(false)
    setLOADINGPARAM_fetchKeyData(false)
    setLOADINGPARAM_fetchNumericData(false)
    // 
    setNumericTimeAggregationMethod("year")
    longstandingGeoJSONRef.current = geoJsonData;
    longstandingGeoJSONRef.current.centroidRef = centroidRef.current.geometry.coordinates;
    let newDataArray = [];
    let invalidFeatures = [];
    longstandingGeoJSONRef.current.features.forEach((feature, i) => {
      let cloned = { ...feature };
      delete cloned.type;
      const coords = cloned.geometry.coordinates[0];
      if (coords.length < 4) {
        invalidFeatures.push(cloned);
      } else {
        newDataArray.push(cloned);
      }
      longstandingGeoJSONRef.current.features[i].feature_data_standard = {
        ...longstandingGeoJSONRef.current.features[i].feature_data_standard,
        layer: 1,
      };
    });
    if (isThisFirstLoadOfNewData === 0) {
      originalGeoJSONforComparingRef.current = JSON.parse(JSON.stringify(geoJsonData));
      isThisFirstLoadOfNewData = 1;
    }
    setRecentChangeList([])
    setYearsAvailable(getAvailableYears(longstandingGeoJSONRef.current));
    // 
    setLOADINGPARAM_startOfLoad(true)
    if (mapRef.current) {
      fmesh.children.forEach((child) => {
        child.geometry.dispose();
        child.material.dispose();
        fmesh.remove(child);
      });
      fullmesh.children.forEach((child) => {
        fullmesh.remove(child);
      });
      fmesh.children.length = 0;
      fullmesh.children.length = 0;
      if (mapRef.current.getLayer('Polygons')) {
        mapRef.current.removeLayer('Polygons');
      }
      let startPoint = null;
      const DRAG_THRESHOLD = 3;
      mapRef.current.on('mousedown', (e) => {
        if (e.originalEvent.button !== 0) return;
        startPoint = e.point;
      });
      mapRef.current.on('mouseup', (e) => {
        if (e.originalEvent.button !== 0) return;
        const dx = e.point.x - startPoint.x;
        const dy = e.point.y - startPoint.y;
        const distance = Math.sqrt(dx * dx + dy * dy);
        if (distance < DRAG_THRESHOLD) {
          polygonCustomLayerRef.current.raycast(e.point, false);
        }
      });
      const bounds = bbox(longstandingGeoJSONRef.current);
      initiallyLoadedDataBoundingBox.current = bounds;
      mapRef.current.fitBounds(
        [
          [bounds[0], bounds[1]],
          [bounds[2], bounds[3]],
        ],
        {
          padding: 20,
          duration: 2,
          pitch: 60,
          bearing: -20
        }
      );
      setTimeout(() => {
        if (userID) {
          setInitialDataLoadComplete(true);
        }
      }, 5000);
    }
  };

  // START STAGE 4 - FETCH THE USERS INITIAL OR SELECTED GEOJSON FROM THE API - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
  // START STAGE 4 - FETCH THE USERS INITIAL OR SELECTED GEOJSON FROM THE API - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
  // START STAGE 4 - FETCH THE USERS INITIAL OR SELECTED GEOJSON FROM THE API - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

  const getBoundingBoxFromViewport = () => {
    if (!mapRef.current) throw new Error('Map reference not available');
    const bounds = mapRef.current.getBounds();
    const sw = bounds.getSouthWest();
    const ne = bounds.getNorthEast();
    return `${sw.lng} + ${sw.lat} + ${ne.lng} + ${ne.lat}`;
  };

  const fetchInitialGeoJsonForInitialView = async (id, simplify) => {

    const token = localStorage.getItem('token');

    const srid = 4326;

    if (!token) {
      throw new Error('No token in local storage');
    }

    const bb = getBoundingBoxFromViewport();

    const params = new URLSearchParams({
      srid: String(srid),
      properties: 'shortname, layer',
      simplify: String(simplify ?? 6),
    });

    const response = await fetch(
      `${apiBaseUrl}/api/maps/${id}/features?${params.toString()}`,
      {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );

    if (!response.ok) {

      const errorText = await response.text();

      throw new Error(
        `Feature request failed: ${response.status} ${errorText}`
      );

    }

    const geoJsonData = await response.json();

    const responseData = geoJsonData;

    const convertCoordinates = (geometry) => {

      if (geometry.type === 'Point') {
        return geometry.coordinates;
      }

      if (geometry.type === 'Polygon') {
        return [
          geometry.coordinates[0].map(
            (coord) => [coord[0], coord[1]]
          )
        ];
      }

      // INVESTIGATE THIS FURTHER
      if (geometry.type === 'MultiPolygon') {
        return geometry.coordinates.map(
          (poly) => [
            poly[0].map(
              (coord) => [coord[0], coord[1]]
            )
          ]
        );
      }

      throw new Error(
        `Unsupported geometry type: ${geometry.type}`
      );

    };

    const responseGeoJsonData = {

      type: 'FeatureCollection',

      features: responseData.map((detail) => ({

        type: 'Feature',

        external_ids:
          detail.external_ids,

        feature_data_simple:
          detail.feature_data_simple,

        feature_data_simple_timeseries:
          detail.feature_data_simple_timeseries,

        feature_data_standard: {
          ...detail.feature_data_standard,
        },

        feature_data_standard_calculated:
          detail.feature_data_standard_calculated,

        geometry: {
          type: detail.geometry.type,
          coordinates:
            convertCoordinates(detail.geometry),
        },

        skylark_id:
          detail.skylark_id,

      })),

    };

    centroidRef.current =
      center(responseGeoJsonData);

    newMapFromGeojson(
      responseGeoJsonData,
      id
    );

    return responseGeoJsonData;

  };

  const fetchMapMetaForInitialGeoJSON = async (id) => {

    setAvailableKeys([]);

    setAvailableValues([]);

    setMultuGroupSelectedArray([]);

    const token = localStorage.getItem('token');

    if (!token) {
      throw new Error('No token in local storage');
    }

    const response = await fetch(
      `${apiBaseUrl}/api/maps/${id}`,
      {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );

    if (!response.ok) {

      const errorText = await response.text();

      throw new Error(
        `Map metadata request failed: ${response.status} ${errorText}`
      );

    }

    const mapOverview = await response.json();

    if (debugMode) {

      const timestamp =
        new Date().toISOString();

      console.groupCollapsed(
        `${timestamp} mapOverview`
      );

      console.log(
        JSON.stringify(
          mapOverview,
          null,
          2
        )
      );

      console.groupEnd();

    }

    const workingWithinRealm =
      mapOverview.realms?.length > 0;

    setIsWorkingWithinRealm(
      workingWithinRealm
    );

    setMapOverview(
      mapOverview
    );

    if (
      !mapOverview.owner ||
      mapOverview.owner.id === userID
    ) {

      if (debugMode) {

        console.log(
          "I OWN THIS MAP"
        );

      }

      setUserIsMapOwner(true);

    } else {

      if (debugMode) {

        console.log(
          "I DON'T OWN THIS MAP"
        );

      }

      setUserIsMapOwner(false);

    }

    setMapMetaData(
      mapOverview.feature_header
    );

    setClickedInfoTab(
      "DATA"
    );

    const timeseriesKeysWithinMapMeta =
      mapOverview
        .feature_header
        ?.define_feature_data_simple_timeseries || {};

    const stringKeys = [];

    const stringValues = [];

    if (workingWithinRealm) {

      for (
        const [key, value]
        of Object.entries(
          timeseriesKeysWithinMapMeta
        )
      ) {

        if (
          value.display_hint?.includes(
            'quantifiable'
          )
        ) {

          stringValues.push(key);

        }

      }

    } else {

      for (
        const [key, value]
        of Object.entries(
          timeseriesKeysWithinMapMeta
        )
      ) {

        if (value.type === 'number') {

          stringValues.push(key);

        } else if (value.type === 'string') {

          stringKeys.push(key);

        }

      }

    }

    setAvailableKeys(
      stringKeys
    );

    setAvailableValues(
      stringValues
    );

    return {
      workingWithinRealm,
      availableKeys: stringKeys,
      availableValues: stringValues,
    };
  };

  const fetchInitialMapGeoJSON = async (id) => {
    try {
      currentMapIdRef.current = id;
      baseMapIDRefForRefWhenUsingOriginalLayer.current = id;
      const meta = await fetchMapMetaForInitialGeoJSON(id);
      await fetchInitialGeoJsonForInitialView(
        id,
        simplificationLevelRef.current
      );
    } catch (error) {
      console.error('Error in fetchMapDetails:', error);
    }
  };

  // START STAGE 2 - INITIAL CHECK IF USER LOAD PRIVATE MAP ELSE - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
  // START STAGE 2 - INITIAL CHECK IF USER LOAD PRIVATE MAP ELSE - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
  // START STAGE 2 - INITIAL CHECK IF USER LOAD PRIVATE MAP ELSE - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

  useEffect(() => {

    if (userID) {

      const fetchAllMapDataForSelectingFirstAvailableMapForInitialLoad = async () => {

        try {

          const token = localStorage.getItem('token');

          if (!token) {
            throw new Error('No token in local storage');
          }

          const response = await fetch(
            `${apiBaseUrl}/api/maps`,
            {
              method: 'GET',
              headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
              },
            }
          );

          if (!response.ok) {

            const errorText = await response.text();

            throw new Error(
              `Map request failed: ${response.status} ${errorText}`
            );

          }

          const data = await response.json();

          console.log('Map data response:', data);

          for (let i = 0; i < data.length; i++) {

            if (data[i].title === "Demo Map") {

              data.splice(i, 1);

              break;

            }

          }

          if (
            userID === process.env.REACT_APP_DEV_USER_ID &&
            devDeployment
          ) {

            if (debugMode) {

              const timestamp =
                new Date().toISOString();

              console.log(
                timestamp +
                " " +
                "🤓 Is user a dev? YES"
              );

            }

            fetchInitialMapGeoJSON(
              '7c54872e-f305-4316-99f9-492217514f58'
            );

          } else {

            if (debugMode) {

              const timestamp =
                new Date().toISOString();

              console.log(
                timestamp +
                " " +
                "🥳 Is user a dev? NO"
              );

            }

            fetchInitialMapGeoJSON(
              'fd8fabf7-f618-42f6-85b0-fa3406567860'
            );

          }

        } catch (error) {

          console.error(
            'Error fetching map data:',
            error
          );

        }

      };

      fetchAllMapDataForSelectingFirstAvailableMapForInitialLoad();

    }

  }, [userID, setAdminUser, mapLoaded]);

  // LOAD MAP FUNCTIONALITY (PRIVATE) - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

  useEffect(() => {
    if (clickedMapIDtoLoad) {
      fetchInitialMapGeoJSON(clickedMapIDtoLoad);
    }
  }, [clickedMapIDtoLoad]);

  // START STAGE 1 - WHEN THE MAP LAYER IS LOADED CHECK IF USER LOGGED IN - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
  // START STAGE 1 - WHEN THE MAP LAYER IS LOADED CHECK IF USER LOGGED IN - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
  // START STAGE 1 - WHEN THE MAP LAYER IS LOADED CHECK IF USER LOGGED IN - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

  useEffect(() => {
    if (mapData && initFetch === 0 && mapLoaded === true) {
      const getUserInfo = async () => {
        try {
          setIsLoading(true);
          const token = localStorage.getItem('token');
          console.log('Token:', token);
          if (!token) {
            throw new Error('No token in local storage');
          }
          const response = await fetch(
            `${apiBaseUrl}/api/info`,
            {
              method: 'GET',
              headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
              }
            }
          );
          if (!response.ok) {
            const errorText = await response.text();
            throw new Error(
              `User info request failed: ${response.status} ${errorText}`
            );
          }
          const data = await response.json();
          console.log('User info response:', data);
          setUserEmail(data.user.email);
          const timestamp =
            new Date().toISOString();
          if (debugMode) {
            console.log(
              timestamp +
              " " +
              "✅ Logged in user id: " +
              data.user.id
            );
          }
          setUserID(data.user.id);
          setisMenuLoadClick(false);
          setLoggedInToAPI(true);
          setGlobalPublicSelectedDataset(null);
        } catch (error) {
          console.error(
            'Error fetching user info:',
            error
          );
          setLoggedInToAPI(false);
          setisMenuLoadClick(true);
          // loadPublicData();
        } finally {
          setIsLoading(false);
        }
      };
      getUserInfo();
      setInitFetch(1);
    }
  }, [mapData, initFetch, mapLoaded]);

  return (
    <>
    </>
  )
};

export default DataLoad;
